import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../config/firebase';

/**
 * Track Firebase Auth readiness so Firestore subscribers don't race ahead of
 * sign-in (which would fail rules with `request.auth == null`).
 *
 * `ready` flips true after the first onAuthStateChanged tick (regardless of
 * whether a user is signed in). `uid` is non-null only when actually signed in.
 *
 * Caller pattern:
 *   const { ready, uid } = useFirebaseAuthReady();
 *   useEffect(() => {
 *     if (!ready || !uid) return;
 *     // safe to onSnapshot here
 *   }, [ready, uid]);
 */
export function useFirebaseAuthReady(): { ready: boolean; uid: string | null } {
  const [state, setState] = useState<{ ready: boolean; uid: string | null }>({
    ready: false,
    uid: null,
  });

  useEffect(() => {
    return onAuthStateChanged(auth, (fbUser) => {
      setState({ ready: true, uid: fbUser?.uid ?? null });
    });
  }, []);

  return state;
}
